import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { setToken, formatApiErrorDetail } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/admin/auth/login", { email, password });
      setToken(data.access_token);
      await refresh();
      toast.success(`Bienvenue — ${data.admin_role}`);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-amber-600/10 blur-3xl" />
      <div className="w-full max-w-md relative z-10">
        <div className="flex items-center gap-2 justify-center mb-8">
          <img src={process.env.PUBLIC_URL + "/cehnura-mark.png"} alt="Cehnura" className="w-9 h-9 object-contain" />
          <span className="font-display font-extrabold text-2xl">Cehnura <span className="gold-text">Admin</span></span>
        </div>
        <div className="bg-[#18181E] border border-zinc-800 rounded-3xl p-8">
          <h1 className="font-display text-2xl font-bold mb-1">Back-office</h1>
          <p className="text-sm text-zinc-500 mb-6">Accès réservé à l'équipe Cehnura.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-zinc-400 mb-1.5">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" required
                className="w-full h-12 px-4 rounded-xl bg-zinc-900 border border-zinc-800 text-zinc-100 focus:border-amber-500 outline-none" placeholder="admin@cehnura.com" />
            </div>
            <div>
              <label className="block text-xs font-medium text-zinc-400 mb-1.5">Mot de passe</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" required
                className="w-full h-12 px-4 rounded-xl bg-zinc-900 border border-zinc-800 text-zinc-100 focus:border-amber-500 outline-none" placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit"
              className="w-full h-12 rounded-xl gold-gradient text-black font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
